import { useState } from "react";
const Range = ({ min, max, value, onChange, disabled }) => {
  const [rangeValue, setRangeValue] = useState(value);
  const handleChange = (e) => {
    onChange(e.target.value);
    setRangeValue(e.target.value);
  };

  return (
    <div className="w-100">
      <p className="text-end fs-4 fw-bold mb-0">{rangeValue}</p>
      <input
        type="range"
        className="form-range"
        min={min}
        max={max}
        value={rangeValue}
        onChange={handleChange}
        disabled={disabled}
      />
      <div className="d-flex justify-content-between">
        <p className="range-value">{min}</p>
        <p className="range-value">{max}</p>
      </div>
    </div>
  );
};
export default Range;
